/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CallForwardingNumber/view.blocks to change it.
import * as fromData from 'Simple/Data'
import InputPhoneSmallLabel from 'DesignSystem/InputPhoneSmallLabel/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CallForwardingNumber({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Comms/Phones/AddPhoneNumber/Content/CallForwardingNumber",
  onChange,
  onSubmit
  
}) {
let phoneNumberCallForwardingNumberValueData = fromData.useDataValue({ viewPath,
context: 'phone_number',
path: 'call_forwarding_number',
})
let phoneNumberCallForwardingNumberChangeData = fromData.useDataChange({ viewPath,
context: 'phone_number',
path: 'call_forwarding_number',
})
let phoneNumberCallForwardingNumberSubmitData = fromData.useDataSubmit({ viewPath,
context: 'phone_number',
})
  return (<React.Fragment
>
<InputPhoneSmallLabel
  viewPath={`${viewPath}/InputPhoneSmallLabel`}
 label="Call forwarding number"
 marginRight={10}
 data="phone_number.call_forwarding_number"
 validate="/Data/validate.js phoneNumber"
 value={phoneNumberCallForwardingNumberValueData}
 onChange={phoneNumberCallForwardingNumberChangeData}
 onSubmit={phoneNumberCallForwardingNumberSubmitData}
/>
{children}
</React.Fragment>)
}